
export const Navbar = () => {
    return(
        <nav className="navbar navbar-dark bg-dark">
            <a href="/" className="navbar-brand mx-3">Efe Hançer</a>
            <ul className="m-0 p-0">
            <a href="/" className="navbar-brand">Projelerim</a>
            <a href="/" className="navbar-brand">İletişim</a>
            </ul>
        </nav>
    )
}

